import {DiscountCardInformationSection as DiscountCardInformationSectionType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/discount_card_information_section.types';
import React from 'react';
import {CouponBanner} from '../Coupons/CouponBanner/CouponBanner';
import {HighTierCouponCard} from './HighTierCouponCard';
interface HighTierCouponProductCardProps {
  discountCardInformationSection: DiscountCardInformationSectionType;
}

export const DiscountCardInformationSection = (
  props: HighTierCouponProductCardProps,
) => {
  if (
    props.discountCardInformationSection.type?.$case === 'highTierCouponBanner'
  ) {
    return (
      <CouponBanner
        banner={props.discountCardInformationSection.type.highTierCouponBanner}
      />
    );
  }

  if (
    props.discountCardInformationSection.type?.$case === 'highTierCouponCard'
  ) {
    return (
      <HighTierCouponCard
        card={props.discountCardInformationSection.type.highTierCouponCard}
      />
    );
  }
  return null;
};
